import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import ExternalLink from 'components/lib/external_link';
import { FlightAttributesPropTypes } from './expanded_flight_transaction';
import { FlightTransactionDef, OrderTransactionDef, StayTransactionDef } from 'models/configuration/transaction_def';
import ExpandedTransaction from './expanded_transaction';
import { OrderAttributesPropTypes } from './order_transactions';
import { ProfileCardType } from 'models/configuration/profile_card_def';
import { StayAttributesPropTypes } from './stay_transactions';
import DownChevronIcon from 'components/lib/icons/down_chevron_and_fill_icon';

export class GeneralTransaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: props.isExpanded || false };
    this.handleClickExpand = this.handleClickExpand.bind(this);
  }

  render() {
    const { attributes, headerAttributes, transactionDef } = this.props;
    return (
      <div className="transaction">
        <div className="transaction-summaryRow">
          {this.props.summaryRenderer(headerAttributes || attributes)}
          {this.renderExpandButton()}
        </div>
        <ExpandedTransaction
          attributes={attributes}
          isExpanded={this.state.isExpanded}
          headerRenderer={this.props.headerRenderer}
          transactionDef={transactionDef}
        />
      </div>
    );
  }

  renderExpandButton() {
    const buttonClassNames = classnames('transaction-expandInfoButton', {
      'transaction-expandInfoButton-open': this.state.isExpanded,
    });

    return (
      <div className={buttonClassNames} onMouseDown={this.handleClickExpand} ref={node => (this.button = node)}>
        <DownChevronIcon />
      </div>
    );
  }

  handleClickExpand(evt) {
    evt.preventDefault();
    this.setState(prevState => {
      this.props.onExpand && this.props.onExpand({ isExpanded: !prevState.isExpanded });
      return { isExpanded: !prevState.isExpanded };
    });
  }
}

GeneralTransaction.propTypes = {
  attributes: PropTypes.oneOfType([FlightAttributesPropTypes, OrderAttributesPropTypes, StayAttributesPropTypes]),
  headerAttributes: PropTypes.object,
  headerRenderer: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  summaryRenderer: PropTypes.func,
  transactionDef: PropTypes.oneOfType([
    PropTypes.instanceOf(FlightTransactionDef),
    PropTypes.instanceOf(OrderTransactionDef),
    PropTypes.instanceOf(StayTransactionDef),
  ]).isRequired,
  onExpand: PropTypes.func,
};

export default function TransactionGroup({
  groupClassName,
  groupName,
  headerRenderer,
  shouldExpandFirst,
  summaryRenderer,
  transactions,
  transactionDef,
  onExpand,
  type,
}) {
  if (!transactions || transactions.length === 0) {
    return null;
  }

  let urlAttribute = transactionDef && transactionDef.urlAttribute;
  let url = _.get(
    urlAttribute ? _.find(transactions, t => !!t.attributes[urlAttribute]) : undefined,
    `attributes.${urlAttribute}`
  );

  let classNames = classnames('transactionGroup-header', groupClassName);

  return (
    <div className="transactionGroup">
      {groupName && (
        <div className={classNames}>
          <ExternalLink
            url={url}
            text={groupName}
            className="transactionGroup-externalLink"
            type={ProfileCardType.TRANSACTIONS}
            subType={type}
            attrName={urlAttribute}
          />
        </div>
      )}
      {_.map(transactions, (t, idx) => (
        <GeneralTransaction
          headerRenderer={headerRenderer}
          isExpanded={shouldExpandFirst ? idx === 0 : false}
          summaryRenderer={summaryRenderer}
          attributes={t.attributes}
          key={t.id}
          transactionDef={transactionDef}
          onExpand={onExpand}
        />
      ))}
    </div>
  );
}

TransactionGroup.propTypes = {
  onExpand: PropTypes.func,
  groupClassName: PropTypes.string,
  groupName: PropTypes.string,
  headerRenderer: PropTypes.func,
  shouldExpandFirst: PropTypes.bool,
  summaryRenderer: PropTypes.func,
  transactionDef: PropTypes.oneOfType([
    PropTypes.instanceOf(FlightTransactionDef),
    PropTypes.instanceOf(OrderTransactionDef),
    PropTypes.instanceOf(StayTransactionDef),
  ]).isRequired,
  transactions: PropTypes.arrayOf(PropTypes.any),
  type: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/transactions/transaction_group.jsx